import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1291456030/src/src/app/ui/common/side-menu.tsx");
